import { z } from "zod";

const userStatusSchema = z.enum(["active", "banned"]);
const adminRoleSchema = z.enum(["super_admin", "admin"]);

export const userResponseSchema = z.object({
  id: z.string(),
  tg_id: z.number(),
  username: z.string().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  status: userStatusSchema,
  created_at: z.string(),
});

export const adminProfileResponseSchema = z.object({
  role: adminRoleSchema,
  totp_enabled: z.boolean(),
});

export const meResponseSchema = z.object({
  user: userResponseSchema,
  is_admin: z.boolean(),
  totp_verified: z.boolean(),
  admin: adminProfileResponseSchema.nullable(),
  admin_role: adminRoleSchema.nullable().default(null),
});

export const userListItemSchema = z.object({
  id: z.string(),
  tg_id: z.number(),
  username: z.string().nullable(),
  first_name: z.string().nullable(),
  status: userStatusSchema,
  created_at: z.string(),
});

export const userListResponseSchema = z.object({
  items: z.array(userListItemSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});
